import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGreenArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.37999 21.01C7.86999 21.5 8.65999 21.5 9.14999 21.01L17.46 12.7C17.5527 12.6075 17.6262 12.4976 17.6764 12.3767C17.7266 12.2557 17.7524 12.126 17.7524 11.995C17.7524 11.8641 17.7266 11.7344 17.6764 11.6134C17.6262 11.4925 17.5527 11.3826 17.46 11.29L9.14999 2.98005C8.65999 2.49005 7.86999 2.49005 7.37999 2.98005C6.88999 3.47005 6.88999 4.26005 7.37999 4.75005L14.62 12L7.36999 19.25C6.88999 19.73 6.88999 20.5301 7.37999 21.01Z",
		fill: "#55721D"
	})
});
export default SvgGreenArrow;
